import { render, staticRenderFns } from "./DocusignAddSignerRole.vue?vue&type=template&id=7b851c58&"
import script from "./DocusignAddSignerRole.vue?vue&type=script&lang=ts&"
export * from "./DocusignAddSignerRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports